import { async } from "regenerator-runtime";
import { API_URL, API_KEY, RECIPES_PER_PAGE } from "./config";
import { AJAX } from "./helpers";

export const state = {
    recipe: {},
    search: {
        query: ``,
        results: [],
        page: 1,
        resultsPerPage: RECIPES_PER_PAGE,
    },
    bookmarks: [],
};

const createRecipeObject = function(data) {
    const { recipe } = data.data;
    return {
        id: recipe.id,
        title: recipe.title,
        publisher: recipe.publisher,
        sourceUrl: recipe.source_url,
        image: recipe.image_url,
        servings: recipe.servings,
        cookingTime: recipe.cooking_time,
        ingredients: recipe.ingredients,
        ...(recipe.key && { key: recipe.key })
        };
}

export const loadRecipe = async function(id) {
    try {

        const data = await AJAX(`${API_URL}/${id}?key=${API_KEY}`);
        state.recipe = createRecipeObject(data);

        const { recipe } = data.data;
        state.recipe = {
        id: recipe.id,
        title: recipe.title,
        publisher: recipe.publisher,
        sourceUrl: recipe.source_url,
        image: recipe.image_url,
        servings: recipe.servings,
        cookingTime: recipe.cooking_time,
        ingredients: recipe.ingredients,
        };
        if (state.bookmarks.some((bookmark) => bookmark.id === id)) {
          state.recipe.bookmarked = true;}
        else {
            state.recipe.bookmarked = false;
        }

        console.log(state.recipe);
    
    } catch(err) {
    
        throw err;
    };
};

export const loadSearchResults = async function (query) {
    try {
        state.search.query = query;
        const data = await AJAX(`${API_URL}?search=${query}&key=${API_KEY}`);

        state.search.results = data.data.recipes.map(recipe => {
            return {
                id: recipe.id,
                title: recipe.title,
                publisher: recipe.publisher,
                image: recipe.image_url,
                ...(recipe.key && { key: recipe.key })
            };
        });
        state.search.page = 1;
    } catch(err) {
        console.error(`${err}`);
        throw err;
    }
};

export const getSearchResultsPage = function(page = state.search.page) {
    state.search.page = page;

    const start = (page - 1) * state.search.resultsPerPage;
    const end = page * state.search.resultsPerPage;

    return state.search.results.slice(start, end);
};

export const updateServings = function(noServings) {
    state.recipe.ingredients.forEach(ingredient => {
        ingredient.quantity = (ingredient.quantity * noServings) / state.recipe.servings; 
    });

    state.recipe.servings = noServings;
};

const persistBookmarks = function() {localStorage.setItem(`bookmarks`, JSON.stringify(state.bookmarks));
};

export const addBookmark = function(recipe) {
    state.bookmarks.push(recipe);

    if(recipe.id === state.recipe.id) state.recipe.bookmarked = true;

    persistBookmarks();
};

export const removeBookmark = function(id) {
    const index = state.bookmarks.findIndex(element => element.id === id);
    state.bookmarks.splice(index, 1);

    if (id === state.recipe.id) state.recipe.bookmarked = false;

    persistBookmarks();
};

const init = function() {
    const storage = localStorage.getItem(`bookmarks`);

    if(storage) state.bookmarks = JSON.parse(storage);
};

init();

const clearBookmarks = function () {
  localStorage.clear(`bookmarks`);
};
//clearBookmarks();

export const uploadRecipe = async function(newRecipe) {
    try {
    const ingredients = Object.entries(newRecipe)
    .filter(entry => entry[0].startsWith(`ingredient`) && entry[1] !== ``)
    .map(ingredient => {
        const ingredientsArr = ingredient[1]
        .split(`,`)
        .map(element => element.trim());
        if(ingredientsArr.length !== 3) throw new Error(`Wrong ingredient format - please input using the correct format.`);
        
        const [quantity, unit, description] = ingredientsArr;
        
        return {quantity: quantity ? +quantity : null, unit, description};
    });

    const recipe = {
      title: newRecipe.title,
      source_url: newRecipe.sourceUrl,
      image_url: newRecipe.image,
      publisher: newRecipe.publisher,
      cooking_time: +newRecipe.cookingTime,
      servings: +newRecipe.servings,
      ingredients,
    };

    const data = await AJAX(`${API_URL}?key=${API_KEY}`, recipe);
    state.recipe = createRecipeObject(data);
    addBookmark(state.recipe);

    } catch(err) {

        throw err;

    } 
};
